import { all } from 'redux-saga/effects';
import reportTypeSaga from './ReportType';

export default function* reportTypeModuleSaga() {
  yield all([reportTypeSaga()]);
}
